<template>
    <tr>
        <td>{{ index +1}}</td>
        <td><input type="text" v-model="label"></td>
        <td style="width: 95px">
            <button type="button" class="button red" @click="remove(label)"><i class="ico-delete"></i></button>
            <button v-if="preventLabel != label" type="button" class="button" @click="save()"><i class="ico-save"></i></button>
        </td>
    </tr>
</template>
<script>
export default {
    name: "Attribute",
    data(){
        return {
            preventLabel: false,
            preventValue: 'rotulo'
        }
    },
    props: {
        index: {
            type: Number
        },
        remove:{
            type: Function
        },
        label: {
            type: String
        },
        value: {
            type: [Boolean]
        },
        change: {
            type: Function
        }
    },
    mounted(){
        this.preventLabel = this.label
        this.preventValue = this.value
    },
    watch: {
        // label(nV){
        //     this.change('label', nV)
        // },
        // value(nV){
        //     this.change('value', nV)
        // }
    },
    methods:{
        save(){
                this.change(this.index, this.label)
                this.preventLabel = this.label
            
        }
    }
}
</script>